"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var mobx_1 = require("mobx");
var inversify_react_1 = require("inversify-react");
var EditableHeadingComponent_1 = require("CommonUI/EditableHeading/EditableHeadingComponent");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UpsellTooltipContent_1 = __importDefault(require("../../../Common/UpsellTooltip/UpsellTooltipContent"));
var ActiveUsers_1 = __importDefault(require("Project/TopNavigationBar/ActiveUsers/ActiveUsers"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CollaborateButtonPanel_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/PopoverComponents/CollaborateButtonPanel");
var SharePagePopover_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/PopoverComponents/SharePagePopover");
var ActionButtonsController_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/ActionButtonsController");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var Utils_1 = require("@CommonFrontendBackend/Templates/Utils");
var PageStatusAndValue_1 = require("./PageStatusAndValue");
var ManualPageValueModal_1 = require("Project/Actions/ManualPageValue/ManualPageValueModal");
var SharePopoverButton_1 = require("Project/SharePopover/SharePopoverButton");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var PageSettingsButton_1 = __importDefault(require("Project/SharePopover/Buttons/PageSettingsButton"));
var ShareButton_1 = __importDefault(require("Project/SharePopover/Buttons/ShareButton"));
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var DefaultNavigationButtons = (function (_super) {
    __extends(DefaultNavigationButtons, _super);
    function DefaultNavigationButtons() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.forceShareOpen = false;
        _this.handleUpdateHeading = function (newHeading) {
            var projectStore = _this.props.projectStore;
            document.title = newHeading;
            projectStore.updateName(newHeading);
        };
        _this.renderButtons = function () {
            if (_this.props.projectStore.isTemplate) {
                return _this.renderTemplateButtons();
            }
            return _this.renderEditorButtons();
        };
        _this.renderTemplateButtons = function () {
            var _a = _this.props, actionButtons = _a.actionButtons, inviteNewUserModal = _a.inviteNewUserModal, modal = _a.modal, permissionsService = _a.permissionsService, projectStore = _a.projectStore, rootDataStore = _a.rootDataStore, showUpsellTooltip = _a.showUpsellTooltip, telemetry = _a.telemetry;
            var showUpsell = showUpsellTooltip ? { "data-tip": true, "data-for": "navigation-button-upsell" } : {};
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: { position: "relative" } },
                    react_1.default.createElement(SharePagePopover_1.SharePagePopoverComponent, { action: {
                            name: ActionButtonsController_1.TopNavigationButtonsNames.ShareWithTeam,
                            icon: react_1.default.createElement(icons_1.Team, null),
                            actionClass: "share-with-team",
                            internalName: "shareWithTeam",
                            tooltipSize: kaleidoscope_2.TooltipSize.Large,
                            disabled: !permissionsService.isAllowed(projectStore.userAction, "all"),
                            disabledReason: "Only admins and the project owner can share with team",
                        }, inviteNewUserModal: inviteNewUserModal, projectStore: projectStore, rootDataStore: rootDataStore, telemetry: telemetry, shouldDisableButtonAccess: false, modal: modal })),
                react_1.default.createElement(react_1.default.Fragment, null, _this.templatePageSettingsPopoverButton()),
                react_1.default.createElement(kaleidoscope_1.Button, { className: "button--create-page", type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Medium, buttonState: kaleidoscope_3.ButtonState.Idle, onClick: _this.createPageFromTemplate }, "Create page"),
                react_1.default.createElement("div", __assign({}, showUpsell), actionButtons)));
        };
        _this.renderEditorButtons = function () {
            var _a = _this.props, actionButtons = _a.actionButtons, showUpsellTooltip = _a.showUpsellTooltip;
            var showUpsell = showUpsellTooltip ? { "data-tip": true, "data-for": "navigation-button-upsell" } : {};
            return (react_1.default.createElement(react_1.default.Fragment, null,
                _this.renderCollaborateButton(),
                react_1.default.createElement(react_1.default.Fragment, null, _this.sharePopoverButton()),
                react_1.default.createElement("div", __assign({}, showUpsell), actionButtons)));
        };
        _this.renderCollaborateButton = function () {
            var _a = _this.props, inviteNewUserModal = _a.inviteNewUserModal, modal = _a.modal, permissionsService = _a.permissionsService, projectStore = _a.projectStore, rootDataStore = _a.rootDataStore, telemetry = _a.telemetry;
            if (permissionsService.isAllowed(projectStore.userAction, "all")) {
                return (react_1.default.createElement(CollaborateButtonPanel_1.CollaborateButtonPanel, { inviteNewUserModal: inviteNewUserModal, projectStore: projectStore, rootDataStore: rootDataStore, telemetry: telemetry, modal: modal }));
            }
            return (react_1.default.createElement(kaleidoscope_2.Tooltip, { wrapTarget: true, size: kaleidoscope_2.TooltipSize.Large, content: "Only admins and the project owner can share with team", position: kaleidoscope_2.TooltipPosition.Bottom },
                react_1.default.createElement(CollaborateButtonPanel_1.CollaborateButtonPanel, { disabled: true, inviteNewUserModal: inviteNewUserModal, projectStore: projectStore, rootDataStore: rootDataStore, telemetry: telemetry, modal: modal })));
        };
        _this.createPageFromTemplate = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _id, _b, projectLink, name, crmInfo;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props.projectStore, _id = _a._id, _b = __read(_a.links, 1), projectLink = _b[0], name = _a.name, crmInfo = _a.crmInfo;
                        return [4, this.props.pageCreationHelper.createPageFromTemplate({
                                projectId: _id,
                                name: name,
                                crmInfo: crmInfo,
                                isAccountTemplate: true,
                                isAutoExpiryEnabled: (0, Utils_1.isAutoExpiryEnabled)(projectLink),
                                isSecurityEnabled: (0, Utils_1.isSecurityEnabled)(projectLink),
                            }, { isOnboarding: false })];
                    case 1:
                        _c.sent();
                        return [2];
                }
            });
        }); };
        return _this;
    }
    DefaultNavigationButtons.prototype.render = function () {
        var _this = this;
        var _a = this.props, projectStore = _a.projectStore, isEditable = _a.isEditable, activeUsersStore = _a.activeUsersStore, initSubscription = _a.initSubscription, withActiveUsers = _a.withActiveUsers;
        var showActiveUsers = withActiveUsers && activeUsersStore.allUsers.length > 0;
        return (react_1.default.createElement("section", { className: "project-navigation-actions" },
            projectStore.isTemplate && (react_1.default.createElement("div", { className: "project-type-container__template" },
                react_1.default.createElement(kaleidoscope_1.Heading, { className: "project-type-container__text", level: "5" }, "Template"))),
            react_1.default.createElement("div", { className: "project-name-container project-name-container--default" },
                react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.navBarZIndex }, function () { return (react_1.default.createElement(EditableHeadingComponent_1.EditableHeading, { heading: projectStore.name, canEditHeading: isEditable, onUpdateHeading: _this.handleUpdateHeading, placeholder: "Untitled" })); })),
            !projectStore.isTemplate && this.renderPageStatusIndicator(),
            showActiveUsers && (react_1.default.createElement("div", { className: "active-users-container" },
                react_1.default.createElement(ActiveUsers_1.default, { users: activeUsersStore.allUsers }))),
            this.renderButtons(),
            react_1.default.createElement(react_tooltip_1.default, { id: "navigation-button-upsell", effect: "solid", place: "bottom", className: "q-tooltip top-helper-theme", clickable: true, delayHide: 1000 },
                react_1.default.createElement(UpsellTooltipContent_1.default, { upgradePosition: "start", message: "to share, preview, or download Qwilr Pages with a Quote or Accept block.", initSubscription: initSubscription }))));
    };
    DefaultNavigationButtons.prototype.renderPageStatusIndicator = function () {
        var _a = this.props, projectStore = _a.projectStore, pageQuoteTotalStore = _a.pageQuoteTotalStore, modal = _a.modal;
        return (react_1.default.createElement(PageStatusAndValue_1.PageStatusAndValue, { pageQuoteTotalStore: pageQuoteTotalStore, pageStatus: projectStore.status, manualPageValue: projectStore.manualPageValue, showManualPageValueModal: function () { return (0, ManualPageValueModal_1.showManualPageValueModal)(modal, projectStore, pageQuoteTotalStore); }, openSharePopover: this.forceSharePopoverToOpen }));
    };
    DefaultNavigationButtons.prototype.templatePageSettingsPopoverButton = function () {
        var _this = this;
        var _a = this.props, gotoPage = _a.gotoPage, projectStore = _a.projectStore, pageQuoteTotalStore = _a.pageQuoteTotalStore;
        return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 10 }, function () { return (react_1.default.createElement(SharePopoverButton_1.SharePopoverButton, { button: PageSettingsButton_1.default, projectStore: projectStore, pageQuoteTotalStore: pageQuoteTotalStore, usingFeature: _this.usingFeature, gotoPage: gotoPage, source: TelemetryEnums_1.TelemetrySource.Template })); }));
    };
    DefaultNavigationButtons.prototype.sharePopoverButton = function () {
        var _this = this;
        var _a = this.props, gotoPage = _a.gotoPage, projectStore = _a.projectStore, pageQuoteTotalStore = _a.pageQuoteTotalStore;
        return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.blockBorderZIndex }, function () { return (react_1.default.createElement(SharePopoverButton_1.SharePopoverButton, { button: ShareButton_1.default, projectStore: projectStore, pageQuoteTotalStore: pageQuoteTotalStore, usingFeature: _this.usingFeature, gotoPage: gotoPage, source: TelemetryEnums_1.TelemetrySource.Editor, isOpen: _this.forceShareOpen ? true : undefined, onChange: _this.onSharePopoverChange })); }));
    };
    DefaultNavigationButtons.prototype.forceSharePopoverToOpen = function () {
        this.forceShareOpen = true;
    };
    DefaultNavigationButtons.prototype.onSharePopoverChange = function (isOpening) {
        if (this.forceShareOpen && isOpening === false) {
            this.forceShareOpen = false;
        }
    };
    var _a;
    DefaultNavigationButtons.defaultProps = {
        withActiveUsers: false,
    };
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_a = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _a : Object)
    ], DefaultNavigationButtons.prototype, "usingFeature", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DefaultNavigationButtons.prototype, "forceShareOpen", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DefaultNavigationButtons.prototype, "forceSharePopoverToOpen", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], DefaultNavigationButtons.prototype, "onSharePopoverChange", null);
    DefaultNavigationButtons = __decorate([
        mobx_react_1.observer
    ], DefaultNavigationButtons);
    return DefaultNavigationButtons;
}(react_1.default.Component));
exports.default = DefaultNavigationButtons;
